export default __webpack_public_path__ + "static/media/business-model-zoo-4.577be606.svg";